import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { AppContext } from '../../../context/app'
import {
  captureGAEvent,
  convertDurationSmall,
  create_share_url,
  getAudioTrailerUrl,
  getImage,
  getReleaseDate,
  raiseToast,
} from '../../../utils/helper'
import '../contentDetail.css'
import TrailerPlayer from '../../player/trailerPlayer'
import RedCircle from '../../../assets/red_circle.gif'
import GreyCircle from '../../../assets/greycircle.png'
import Player from '../../player/player'
import useAxios from 'axios-hooks'
import { SubscriptionContext } from '../../../context/subscription'
import { isEmpty } from 'lodash'
import { CONTENT_WATCH_URL, DETAIL_CONTENT } from '../../../utils/apiUrls'
import { useLocation, useSearchParams } from 'react-router-dom'
import LiveCounter from '../liveCounter'
import { useTranslation } from 'react-i18next'
import CustomImage from '../../../components/customImage/customImage'
import VideoPlaceholder from '../../../assets/video-content.png'
import { withTheme } from 'theming'
import ShareModal from '../../../components/shareModal/shareModal'
import ContentDetailBottom from '../contentDetailBottom'
import { ContentContext } from '../../../context/content'
import AudioTrailerPlayer from '../../../components/audioPlayer/audioTrailerPlayer'
import PlayIcon from '../../../assets/imgComponents/playIcon'
import NewAddToWatchList from '../../../assets/imgComponents/newAddToWatchlist'
import NewAddToFavorite from '../../../assets/imgComponents/newAddToFavorite'
import BriefcaseIcon from '../../../assets/imgComponents/briefcaseIcon'
import CrownIcon from '../../../assets/imgComponents/crownIcon'
import AggregateRatingReviewWidget from '../../../components/reviewRating/aggregateRatingReviewWidget'
import NewAddedToFavorite from '../../../assets/imgComponents/newAddedToFavorite'
import NewAddedToWatchList from '../../../assets/imgComponents/newAddedToWatchlist'
import ListenIcon from '../../../assets/imgComponents/listenIcon'
import CustomMetadata from '../../../components/customMetadata/customMetadata'
import { useInterval } from '../../../hooks/useInterval'
import NewShareIcon2 from '../../../assets/imgComponents/newShareIcon2'
import NewRestartIcon from '../../../assets/imgComponents/newRestartIcon'

const ContentDetailPageB = (props) => {
  let { theme, data } = props

  const contentId = useParams().contentId
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const { t } = useTranslation()
  const {
    isCustomTemplate,
    isLogin,
    setLoader,
    setOpenLoginModal,
    setModalType,
    modulePermissions,
    accountObj,
    userObj,
    setVerifyOtpModalData,
  } = useContext(AppContext)
  const { setOpenSubscriptionModal, setSubscriptions, setRedirectionUrl, setContentPartners } =
    useContext(SubscriptionContext)
  const {
    isInFavoriteList,
    isInWatchList,
    addRemoveFavouriteList,
    addRemoveWatchList,
    setIsVideoPlaying,
    getResumeTimestamp,
  } = useContext(ContentContext)

  //   const [publishDateTime, setPublishDateTime] = useState(null)
  const [playingVideo, setPlayingVideo] = useState(false)
  const [detailObj, setDetailObj] = useState()
  const [isLive, setIsLive] = useState(false)
  const [resumeTime, setResumeTime] = useState(0)
  const navigate = useNavigate()
  const isWatch = searchParams.get('watch') === 'true'
  const [endTime, setEndTime] = useState(null)
  const [shareModal, setShareModal] = useState(false)
  const [tooltipHover, setTooltipHover] = useState('')

  const [{ data: contentDetail, loading: contentLoading }, contentDetailCall] = useAxios(
    {
      url: `${DETAIL_CONTENT}${contentId}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: contentWatchUrl, loading: contentWatchUrlLoading }, getContentWatchUrl] = useAxios(
    {
      url: `${CONTENT_WATCH_URL}${contentId}`,
      method: 'get',
    },
    { manual: true },
  )

  useInterval(async () => {
    if (
      accountObj?.od_resource_allowances?.content_refresh &&
      (detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE')
    ) {
      await contentDetailCall()
    }
  }, 25000)

  useEffect(() => {
    if (!playingVideo) {
      contentDetailCall()
    }
  }, [playingVideo, contentId, isLogin])

  useEffect(() => {
    if (playingVideo) {
      setPlayingVideo(false)
    }
  }, [contentId])

  useEffect(() => {
    if (!isEmpty(detailObj) && isWatch) {
      handleWatchNow(false)
    }
  }, [detailObj])

  useEffect(() => {
    if (contentDetail && contentDetail.success) {
      const contentObj = contentDetail.data
      setDetailObj(contentObj)
      if (contentObj?.video_type?.includes('LIVE') || contentObj?.audio_type?.includes('LIVE')) {
        let publishTime = new Date(contentObj.publish_time + 'Z')
        // setPublishDateTime(new Date(contentObj.publish_time + 'Z').getTime())

        if (contentObj?.video_type === 'VOD_LIVE' && isEmpty(contentObj?.youtube_data)) {
          setEndTime(
            new Date(
              publishTime.setSeconds(publishTime.getSeconds() + contentObj.duration_in_s),
            ).getTime(),
          )
        } else {
          setEndTime(new Date(contentObj.live_expiry_time + 'Z').getTime())
        }

        if (
          (new Date(contentObj.publish_time + 'Z').getTime() < Date.now() &&
            (!isEmpty(contentObj?.youtube_data) ||
              new Date(
                publishTime.setSeconds(publishTime.getSeconds() + contentObj.duration_in_s),
              ).getTime() > Date.now()) &&
            contentObj?.video_type === 'VOD_LIVE') ||
          (new Date(contentObj.publish_time + 'Z').getTime() < Date.now() &&
            new Date(contentObj.live_expiry_time + 'Z').getTime() > Date.now())
        ) {
          setIsLive(true)
        }
      }
      if (isLogin && !contentDetail?.data?.video_type?.includes('LIVE')) {
        setResumeTime(getResumeTimestamp(contentId))
      }
    }
  }, [contentDetail])

  useEffect(() => {
    if (contentWatchUrl && contentWatchUrl.success) {
      setPlayingVideo(true)
      setIsVideoPlaying(true)
    }
  }, [contentWatchUrl])

  useEffect(() => {
    setLoader((isEmpty(detailObj) && contentLoading) || contentWatchUrlLoading)
  }, [contentLoading, contentWatchUrlLoading])

  const get_video_url = (detailObj) => {
    if (detailObj?.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') {
      setPlayingVideo(true)
      setIsVideoPlaying(true)
    } else {
      getContentWatchUrl()
    }
  }

  const handleWatchNow = (isStartOver = false) => {
    captureGAEvent('content', 'content_watch', 'Content', {
      content_id: contentId,
      name: detailObj?.title,
      user_id: userObj?._id || '',
      user_email: userObj?.email_id || '',
    })
    if (
      (detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') &&
      endTime < Date.now()
    ) {
      raiseToast('error', t('stream_ended_toast'))
      return
    }

    if (!detailObj.is_restricted) {
      if (
        detailObj.is_login_required &&
        isLogin &&
        accountObj?.od_resource_allowances?.verify_email_mandatory &&
        !userObj?.is_email_verified
      ) {
        setVerifyOtpModalData({ title: t('verify_your_email'), email: userObj?.email_id })
        return
      }

      if (detailObj.is_login_required && !isLogin) {
        setModalType('login')
        setOpenLoginModal(true)
      } else {
        if (accountObj?.od_resource_allowances?.player_page) {
          detailObj.video_type === 'MPVC' || detailObj.audio_type === 'MPAC'
            ? navigate(`/series-watch/${contentId}`)
            : navigate(`/content-watch/${contentId}`, { state: { isStartOver: isStartOver } })
          return
        }
        get_video_url(detailObj)
      }
    } else {
      if (!isLogin) {
        setModalType('login')
        setOpenLoginModal(true)
      } else {
        if (
          accountObj?.od_resource_allowances?.verify_email_mandatory &&
          !userObj?.is_email_verified
        ) {
          setVerifyOtpModalData({ title: t('verify_your_email'), email: userObj?.email_id })
          return
        }

        if (detailObj?.is_purchased_required) {
          let activeSub = [...detailObj.active_subscription.map((item) => item.id)]
          let activePPV = [...detailObj.active_ppv_subscription.map((item) => item.id)]

          setRedirectionUrl(window.location.pathname)
          setContentPartners(detailObj?.owner ? detailObj?.owner : [])
          setSubscriptions([...activeSub, ...activePPV])
          setOpenSubscriptionModal(true)
        } else {
          if (accountObj?.od_resource_allowances?.player_page) {
            detailObj.video_type === 'MPVC' || detailObj.audio_type === 'MPAC'
              ? navigate(`/series-watch/${contentId}`)
              : navigate(`/content-watch/${contentId}`, { state: { isStartOver: isStartOver } })

            return
          }
          get_video_url(detailObj)
        }
      }
    }
  }

  const getButtonText = () => {
    if (detailObj?.video_type?.includes('LIVE') || detailObj?.audio_type === 'LIVE') {
      return endTime < Date.now()
        ? t('stream_ended')
        : !isLive
        ? t('streaming_soon')
        : detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE'
        ? t('streaming_live')
        : t('watch_now')
    }

    if (!isLogin || !detailObj.is_restricted || !detailObj?.is_purchased_required) {
      if (detailObj?.asset_type === 'AUDIO') {
        return t('listen_now')
      }
      return resumeTime ? t('resume_watching') : t('watch_now')
    } else {
      return detailObj?.asset_type === 'AUDIO' ? t('upgrade_plan_listen') : t('upgrade_plan')
    }
  }

  const handleCategoryClick = (id, name) => {
    navigate(`/metadata/${id}`)
  }

  const handleSubCategory = (id, name) => {
    navigate(`/sub-category/${id}`)
  }

  const onCounterComplete = () => {
    setIsLive(true)
    handleWatchNow(false)
  }

  const buyTicket = () => {
    if (!isLogin) {
      setModalType('login')
      setOpenLoginModal(true)
    } else {
      let activeSub = [
        ...detailObj.active_subscription.map((item) => item.id),
        ...detailObj.active_ppv_subscription.map((item) => item.id),
      ]
      setSubscriptions(activeSub)
      setOpenSubscriptionModal(true)
      setRedirectionUrl(window.location.pathname)
      setContentPartners(detailObj?.owner ? detailObj?.owner : [])
    }
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data?.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }
  return (
    <>
      {detailObj && (
        <>
          {playingVideo ? (
            <Player
              contentInfo={detailObj}
              handleClose={() => {
                setPlayingVideo(false)
                setIsVideoPlaying(false)
                setResumeTime(0)
                navigate(location.pathname)
              }}
              contentWatchUrl={
                detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE'
                  ? detailObj.stream.link
                  : contentWatchUrl.data.signed_url
              }
              resumeTime={resumeTime}
            />
          ) : (
            <>
              <div
                style={{
                  background: getStyleValue('component_background', 'primary_color', theme.c1),
                }}
                className={`flex justify-center items-center xl:px-[4.375vw] w-full`}
              >
                <div className="w-full flex flex-col justify-center items-center overflow-hidden relative xl:aspect-[2.2909]">
                  <div className="xl:absolute xl:ml-10 hidden lg:flex">
                    {(detailObj?.video_type?.includes('LIVE') ||
                      detailObj?.audio_type?.includes('LIVE')) &&
                      !isLive &&
                      endTime > Date.now() && (
                        <LiveCounter
                          contentDetail={detailObj}
                          handleCompletion={onCounterComplete}
                          removeText={true}
                        />
                      )}
                  </div>

                  <div className="w-full aspect-video relative">
                    {(detailObj.video_type === 'LIVE' || detailObj?.audio_type === 'LIVE') &&
                    !isLive ? (
                      <CustomImage
                        imageUrl={getImage(
                          accountObj?.cf_domain_name,
                          detailObj?.asset_type === 'AUDIO'
                            ? detailObj?.thumbnail
                            : detailObj?.poster,
                        )}
                        loaderClass="new-content-loader"
                        imgAlt="content"
                        imgClass="w-full h-full"
                        errorPlaceholder={VideoPlaceholder}
                      />
                    ) : (
                      <>
                        {detailObj.preview ? (
                          detailObj?.trailer_type === 'AUDIO' ? (
                            <AudioTrailerPlayer
                              url={getAudioTrailerUrl(
                                accountObj?.cf_domain_name,
                                detailObj.preview,
                              )}
                              detailObj={detailObj}
                              accountObj={accountObj}
                              isCustomTemplate={isCustomTemplate}
                              theme={theme}
                            />
                          ) : (
                            <div className="">
                              <TrailerPlayer
                                preview={detailObj.preview}
                                poster={getImage(accountObj?.cf_domain_name, detailObj?.poster)}
                                quality={480}
                                type={'CONTENT'}
                                stream={detailObj.stream}
                                videoType={detailObj.video_type}
                              />
                            </div>
                          )
                        ) : (
                          <CustomImage
                            imageUrl={getImage(
                              accountObj?.cf_domain_name,
                              detailObj?.asset_type === 'AUDIO'
                                ? detailObj?.thumbnail
                                : detailObj?.poster,
                            )}
                            loaderClass="new-content-loader"
                            imgAlt="content"
                            imgClass="w-full h-full"
                            errorPlaceholder={VideoPlaceholder}
                          />
                        )}
                      </>
                    )}

                    <div
                      className="absolute bottom-0 left-0 right-0 pointer-events-none"
                      style={{
                        height: window.innerHeight >= 1280 ? '50%' : '30%',
                        backgroundImage: `linear-gradient(to bottom, transparent 0%, ${getStyleValue(
                          'component_background',
                          'primary_color',
                          theme.c1,
                        )} 100%)`,
                        zIndex: 10,
                      }}
                    ></div>
                  </div>

                  <div className="2xl:w-[1364px] xl:w-[1302px] w-full flex flex-col justify-center xl:absolute top-[40%]">
                    <div className="w-full xl:w-[34%]  2xl:w-[30.329%] xl:hidden block px-4">
                      <p
                        style={{
                          color: getStyleValue('content_title', 'color', ''),
                          fontFamily: getStyleValue('content_title', 'font', ''),
                          lineHeight: 'normal',
                        }}
                        className={`text-2xl md:text-3xl  ${getStyleValue(
                          'content_title',
                          'font_format',
                          'font-semibold',
                        )} mt-3 xl:mt-0`}
                      >
                        {detailObj?.title}
                      </p>
                      <div
                        className={`flex overflow-hidden ${getStyleValue(
                          'sub_heading',
                          'font_format',
                          '',
                        )} mt-3 xl:mt-6`}
                        style={{
                          color: getStyleValue('sub_heading', 'color', '#fff'),
                          fontFamily: getStyleValue('sub_heading', 'font', ''),
                        }}
                      >
                        {!isEmpty(detailObj?.content_rating) ? (
                          <div
                            className="flex items-center justify-center rounded"
                            style={{
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {detailObj?.content_rating?.icon?.s3_key && (
                              <div className="">
                                <img
                                  src={getImage(
                                    accountObj?.cf_domain_name,
                                    detailObj?.content_rating?.icon?.s3_key,
                                  )}
                                  className="h-5"
                                  alt="Rating"
                                />
                              </div>
                            )}
                            <p style={{}} className="ml-1 text-xs md:text-base">
                              {detailObj?.content_rating?.name}
                            </p>
                          </div>
                        ) : null}
                        {detailObj?.release_time ? (
                          <div className="flex items-center">
                            {!isEmpty(detailObj?.content_rating) ? (
                              <div
                                style={{ background: '#09e9e9' }}
                                className="rounded-full ml-2 w-[6px] h-[6px]"
                              />
                            ) : null}

                            <p
                              style={{}}
                              className={`${
                                !isEmpty(detailObj?.content_rating) ? 'ml-2' : ''
                              } text-xs md:text-base`}
                            >
                              {getReleaseDate(detailObj.release_time)}
                            </p>
                          </div>
                        ) : null}
                        {detailObj?.duration ? (
                          <div className="flex items-center">
                            {!isEmpty(detailObj?.content_rating) ? (
                              <div
                                style={{ background: '#09e9e9' }}
                                className="rounded-full ml-2 w-[6px] h-[6px]"
                              />
                            ) : null}

                            <p
                              style={{}}
                              className={`${
                                !isEmpty(detailObj?.content_rating) ? 'ml-2' : ''
                              } text-xs md:text-base`}
                            >
                              {convertDurationSmall(detailObj.duration_in_s)}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <div
                        className={`flex items-center overflow-hidden mt-3  ${
                          isEmpty(detailObj?.content_rating) && !detailObj?.release_time
                            ? 'w-full'
                            : 'w-[60%]'
                        } ${getStyleValue('sub_heading', 'font_format', '')}`}
                        style={{
                          color: getStyleValue('sub_heading', 'color', '#fff'),
                          fontFamily: getStyleValue('sub_heading', 'font', ''),
                        }}
                      >
                        {[...detailObj?.category].map((item, index) => {
                          if (index >= 3) return null

                          const showDot =
                            index > 0 &&
                            (!isEmpty(detailObj?.content_rating) || detailObj?.release_time)

                          return (
                            <div key={index} className="flex items-center">
                              {showDot && (
                                <div
                                  style={{ background: '#09e9e9' }}
                                  className="rounded-full ml-2 w-[6px] h-[6px]"
                                />
                              )}
                              <p
                                onClick={() => handleCategoryClick(item.id, item.name)}
                                className={`cursor-pointer ${
                                  showDot ? 'ml-2' : ''
                                } line-clamp-1 rounded text-xs md:text-base`}
                              >
                                {item.name}
                              </p>
                            </div>
                          )
                        })}
                      </div>
                      {modulePermissions?.rating && (
                        <div className=" mt-3 xl:hidden block">
                          <AggregateRatingReviewWidget
                            value={detailObj.average_rating}
                            ratingCount={detailObj.review_count}
                            starColor={getStyleValue('ratings_reviews', 'star_color', '#ffee00')}
                            bigTextColor={getStyleValue('ratings_reviews', 'text1_color', '#fff')}
                            smallTextColor={getStyleValue('ratings_reviews', 'text2_color', '#bbb')}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      style={{ color: `#fff` }}
                      className={`w-full lg:w-[50%] 2xl:px-8 px-4 xl:px-0 ${
                        detailObj.is_restricted
                          ? 'xl:w-[33%] 2xl:w-[37%]'
                          : 'xl:w-[31%] 2xl:w-[35%]'
                      }`}
                    >
                      <div
                        style={{
                          height: '52px',
                          border: `1px solid ${getStyleValue(
                            'play_button',
                            'background_color2',
                            '#09e9e9',
                          )}`,
                          background: `${getStyleValue(
                            'operational_icon',
                            'operational_icon_bg_color',
                            '#070707',
                          )}50`,
                        }}
                        className={`rounded-full flex items-center justify-between mt-5 xl:mt-0 transition-all duration-300 ${
                          isLogin && resumeTime
                            ? 'w-full xl:min-w-[25%] px-[7px]'
                            : 'w-fit px-[7px]'
                        }`}
                      >
                        <div className="flex items-center gap-1">
                          <div
                            style={{
                              width: '40px',
                              aspectRatio: '1',
                              backgroundImage: `linear-gradient(154deg,${getStyleValue(
                                'play_button',
                                'background_color1',
                                '#2680eb',
                              )} 35%, ${getStyleValue(
                                'play_button',
                                'background_color2',
                                '#09e9e9',
                              )} 83%) `,
                            }}
                            className="rounded-full cursor-pointer flex justify-center items-center hover:scale-[1.05] transition-all duration-300"
                            onClick={() => {
                              ;(detailObj.video_type === 'LIVE' ||
                                detailObj?.audio_type === 'LIVE') &&
                              detailObj.is_restricted &&
                              detailObj?.is_purchased_required
                                ? buyTicket()
                                : handleWatchNow(false)
                              // setResumeTime(detailObj?.resume_timestamp)
                            }}
                          >
                            {detailObj?.asset_type === 'AUDIO' ? (
                              <ListenIcon
                                color={getStyleValue('play_button', 'play_icon_color', '#fff')}
                              />
                            ) : (
                              <PlayIcon
                                color={getStyleValue('play_button', 'play_icon_color', '#fff')}
                                width={14}
                                height={15}
                              />
                            )}
                          </div>
                          <p
                            style={{ color: getStyleValue('play_button', 'button_text', '#fff') }}
                            className="text-xs md:text-sm 2xl:text-base ml-2 font-semibold flex items-center"
                          >
                            {getButtonText()}
                            {endTime < Date.now() ? (
                              ''
                            ) : (
                              <img
                                src={!isLive ? GreyCircle : RedCircle}
                                style={{ width: '12px', height: '12px' }}
                                alt={'live'}
                                className="ml-2 mt-1"
                              />
                            )}
                          </p>
                          <div
                            style={{
                              width: '1px',
                              height: '46px',
                              backgroundColor: `${getStyleValue(
                                'play_button',
                                'background_color2',
                                '#09e9e9',
                              )}`,
                              opacity: 0.5,
                            }}
                            className="ml-4"
                          />
                        </div>

                        <div className={`flex ml-2`} style={{ color: '#fff' }}>
                          <div className="flex items-center rounded-lg">
                            {resumeTime ? (
                              <div
                                onClick={() => handleWatchNow(true)}
                                onMouseOver={() => setTooltipHover('RESUME')}
                                onMouseLeave={() => setTooltipHover('')}
                                style={{
                                  width: '33px',
                                  aspectRatio: '1',
                                  // background: `${getStyleValue(
                                  //   'operational_icon',
                                  //   'operational_icon_bg_color',
                                  //   '#000000',
                                  // )}40`,
                                }}
                                className="rounded-full cursor-pointer flex justify-center items-center relative"
                              >
                                <NewRestartIcon
                                  color={getStyleValue(
                                    'operational_icon',
                                    'operational_icon_color',
                                    '#fff',
                                  )}
                                  hoverColor={getStyleValue(
                                    'operational_icon',
                                    'operational_icon_hover_color',
                                    '#bbfa33',
                                  )}
                                />
                                {tooltipHover === 'RESUME' && (
                                  <div
                                    style={{
                                      left: '15px',
                                      top: '0px',
                                      background: `${getStyleValue(
                                        'operational_icon',
                                        'operational_icon_bg_color',
                                        '#070707',
                                      )}`,
                                      border: `1px solid ${getStyleValue(
                                        'operational_icon',
                                        'operational_icon_hover_color',
                                        '#bbfa33',
                                      )}`,
                                    }}
                                    className="hidden lg:block text-xs px-2.5 rounded absolute ml-3 z-10 w-max"
                                  >
                                    {t('start_over')}
                                  </div>
                                )}
                              </div>
                            ) : null}
                            <div
                              className={`${
                                resumeTime ? 'ml-1 xl:ml-2.5 ' : ''
                              } cursor-pointer relative rounded-full flex justify-center items-center `}
                              onClick={() => setShareModal(true)}
                              onMouseOver={() => setTooltipHover('SHARE')}
                              onMouseLeave={() => setTooltipHover('')}
                              style={{
                                width: '33px',
                                aspectRatio: '1',
                                // background: `${getStyleValue(
                                //   'operational_icon',
                                //   'operational_icon_bg_color',
                                //   '#000000',
                                // )}40`,
                              }}
                            >
                              <NewShareIcon2
                                color={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_color',
                                  '#fff',
                                )}
                                hoverColor={getStyleValue(
                                  'operational_icon',
                                  'operational_icon_hover_color',
                                  '#bbfa33',
                                )}
                              />
                              {tooltipHover === 'SHARE' && (
                                <div
                                  style={{
                                    left: '15px',
                                    top: '0px',
                                    background: `${getStyleValue(
                                      'operational_icon',
                                      'operational_icon_bg_color',
                                      '#070707',
                                    )}`,
                                    border: `1px solid ${getStyleValue(
                                      'operational_icon',
                                      'operational_icon_hover_color',
                                      '#bbfa33',
                                    )}`,
                                  }}
                                  className="hidden lg:block text-xs px-2.5 rounded absolute ml-3 z-10"
                                >
                                  {t('share')}
                                </div>
                              )}
                            </div>
                            {isLogin && (
                              <div className="flex items-center ">
                                <div
                                  className=" ml-2 xl:ml-4 cursor-pointer relative rounded-full flex justify-center items-center"
                                  onClick={() => addRemoveWatchList(contentId)}
                                  onMouseOver={() => setTooltipHover('WATCHLIST')}
                                  onMouseLeave={() => setTooltipHover('')}
                                  style={{
                                    width: '33px',
                                    aspectRatio: '1',
                                    // background: `${getStyleValue(
                                    //   'operational_icon',
                                    //   'operational_icon_bg_color',
                                    //   '#000000',
                                    // )}40`,
                                  }}
                                >
                                  {isInWatchList(contentId) ? (
                                    <NewAddedToWatchList
                                      color={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_color',
                                        '#fff',
                                      )}
                                      hoverColor={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_hover_color',
                                        '#bbfa33',
                                      )}
                                    />
                                  ) : (
                                    <NewAddToWatchList
                                      color={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_color',
                                        '#fff',
                                      )}
                                      hoverColor={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_hover_color',
                                        '#bbfa33',
                                      )}
                                    />
                                  )}
                                  {tooltipHover === 'WATCHLIST' && (
                                    <div
                                      style={{
                                        left: '15px',
                                        top: '0px',
                                        background: `${getStyleValue(
                                          'operational_icon',
                                          'operational_icon_bg_color',
                                          '#070707',
                                        )}`,
                                        border: `1px solid ${getStyleValue(
                                          'operational_icon',
                                          'operational_icon_hover_color',
                                          '#bbfa33',
                                        )}`,
                                      }}
                                      className="hidden lg:block text-xs px-2.5 rounded absolute ml-3 w-max z-10"
                                    >
                                      {isInWatchList(contentId)
                                        ? t('remove_from_watchlist')
                                        : t('add_to_watchlist')}
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="cursor-pointer ml-2 xl:ml-4 relative  rounded-full flex justify-center items-center"
                                  onClick={() => addRemoveFavouriteList(contentId)}
                                  onMouseOver={() => setTooltipHover('FAVORITES')}
                                  onMouseLeave={() => setTooltipHover('')}
                                  style={{
                                    width: '33px',
                                    aspectRatio: '1',
                                    // background: `${getStyleValue(
                                    //   'operational_icon',
                                    //   'operational_icon_bg_color',
                                    //   '#000000',
                                    // )}40`,
                                  }}
                                >
                                  {isInFavoriteList(contentId) ? (
                                    <NewAddedToFavorite
                                      color={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_color',
                                        '#fff',
                                      )}
                                      hoverColor={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_hover_color',
                                        '#bbfa33',
                                      )}
                                    />
                                  ) : (
                                    <NewAddToFavorite
                                      color={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_color',
                                        '#fff',
                                      )}
                                      hoverColor={getStyleValue(
                                        'operational_icon',
                                        'operational_icon_hover_color',
                                        '#bbfa33',
                                      )}
                                    />
                                  )}
                                  {tooltipHover === 'FAVORITES' && (
                                    <div
                                      style={{
                                        left: '15px',
                                        top: '0px',
                                        background: `${getStyleValue(
                                          'operational_icon',
                                          'operational_icon_bg_color',
                                          '#070707',
                                        )}`,
                                        border: `1px solid ${getStyleValue(
                                          'operational_icon',
                                          'operational_icon_hover_color',
                                          '#bbfa33',
                                        )}`,
                                      }}
                                      className="hidden lg:block text-xs px-2.5 rounded absolute ml-3 w-max z-10"
                                    >
                                      {isInFavoriteList(contentId)
                                        ? t('remove_from_favorites')
                                        : t('add_to_favorites')}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {detailObj.is_restricted && (
                            <div
                              className=" ml-3 mr-2 flex items-center justify-center relative "
                              onMouseOver={() => setTooltipHover('PREMIUM_CONTENT')}
                              onMouseLeave={() => setTooltipHover('')}
                            >
                              {detailObj.is_restricted && detailObj?.is_purchased_required ? (
                                <BriefcaseIcon
                                  color={getStyleValue(
                                    'operational_icon',
                                    'informative_icon_color',
                                    '#ffee00',
                                  )}
                                />
                              ) : (
                                <CrownIcon
                                  color={getStyleValue(
                                    'operational_icon',
                                    'informative_icon_color',
                                    '#ffee00',
                                  )}
                                />
                              )}

                              {tooltipHover === 'PREMIUM_CONTENT' && (
                                <div
                                  style={{
                                    left: '80%',
                                    top: '30%',
                                    background: `${getStyleValue(
                                      'operational_icon',
                                      'operational_icon_bg_color',
                                      '#070707',
                                    )}`,
                                    border: `1px solid ${getStyleValue(
                                      'operational_icon',
                                      'operational_icon_hover_color',
                                      '#bbfa33',
                                    )}`,
                                  }}
                                  className="hidden lg:block text-xs px-2.5 rounded absolute ml-3 w-max z-10"
                                >
                                  {detailObj.is_restricted && detailObj?.is_purchased_required
                                    ? t('premium_content')
                                    : t('premium_content_included')}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {modulePermissions?.rating && (
                      <div className=" mt-3 2xl:px-8 px-4 xl:px-0  xl:block hidden">
                        <AggregateRatingReviewWidget
                          value={detailObj.average_rating}
                          ratingCount={detailObj.review_count}
                          starColor={getStyleValue('ratings_reviews', 'star_color', '#ffee00')}
                          bigTextColor={getStyleValue('ratings_reviews', 'text1_color', '#fff')}
                          smallTextColor={getStyleValue('ratings_reviews', 'text2_color', '#bbb')}
                        />
                      </div>
                    )}

                    <div
                      className={` w-full bottom-0 xl:pt-10 2xl:pt-[50px] 2xl:px-8 px-4 xl:px-0 flex justify-center flex-col xl:flex-row gap-5`}
                    >
                      <div className="w-full xl:w-[34%] 2xl:w-[30.329%] xl:block hidden">
                        <p
                          style={{
                            color: getStyleValue('content_title', 'color', ''),
                            fontFamily: getStyleValue('content_title', 'font', ''),
                            lineHeight: 'normal',
                          }}
                          className={`text-2xl md:text-3xl  ${getStyleValue(
                            'content_title',
                            'font_format',
                            'font-semibold',
                          )} mt-3 xl:mt-0`}
                        >
                          {detailObj?.title}
                        </p>
                        <div
                          className={`flex overflow-hidden ${getStyleValue(
                            'sub_heading',
                            'font_format',
                            '',
                          )} mt-3 xl:mt-6`}
                          style={{
                            color: getStyleValue('sub_heading', 'color', '#fff'),
                            fontFamily: getStyleValue('sub_heading', 'font', ''),
                          }}
                        >
                          {!isEmpty(detailObj?.content_rating) ? (
                            <div
                              className="flex items-center justify-center rounded"
                              style={{
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {detailObj?.content_rating?.icon?.s3_key && (
                                <div className="">
                                  <img
                                    src={getImage(
                                      accountObj?.cf_domain_name,
                                      detailObj?.content_rating?.icon?.s3_key,
                                    )}
                                    className="h-5"
                                    alt="Rating"
                                  />
                                </div>
                              )}
                              <p style={{}} className="ml-1 text-xs md:text-base">
                                {detailObj?.content_rating?.name}
                              </p>
                            </div>
                          ) : null}
                          {detailObj?.release_time ? (
                            <div className="flex items-center">
                              {!isEmpty(detailObj?.content_rating) ? (
                                <div
                                  style={{ background: '#09e9e9' }}
                                  className="rounded-full ml-2 w-[6px] h-[6px]"
                                />
                              ) : null}

                              <p
                                style={{}}
                                className={`${
                                  !isEmpty(detailObj?.content_rating) ? 'ml-2' : ''
                                } text-xs md:text-base`}
                              >
                                {getReleaseDate(detailObj.release_time)}
                              </p>
                            </div>
                          ) : null}
                          {detailObj?.duration_in_s !== 0 ? (
                            <div className="flex items-center">
                              {!isEmpty(detailObj?.content_rating) ? (
                                <div
                                  style={{ background: '#09e9e9' }}
                                  className="rounded-full ml-2 w-[6px] h-[6px]"
                                />
                              ) : null}

                              <p
                                style={{}}
                                className={`${
                                  !isEmpty(detailObj?.content_rating) ? 'ml-2' : ''
                                } text-xs md:text-base`}
                              >
                                {convertDurationSmall(detailObj.duration_in_s)}
                              </p>
                            </div>
                          ) : null}
                        </div>
                        <div
                          className={`flex items-center overflow-hidden mt-3  ${
                            isEmpty(detailObj?.content_rating) && !detailObj?.release_time
                              ? 'w-full'
                              : 'w-[60%]'
                          } ${getStyleValue('sub_heading', 'font_format', '')}`}
                          style={{
                            color: getStyleValue('sub_heading', 'color', '#fff'),
                            fontFamily: getStyleValue('sub_heading', 'font', ''),
                          }}
                        >
                          {[...detailObj?.category].map((item, index) => {
                            if (index >= 3) return null

                            const showDot =
                              index > 0 &&
                              (!isEmpty(detailObj?.content_rating) || detailObj?.release_time)

                            return (
                              <div key={index} className="flex items-center">
                                {showDot && (
                                  <div
                                    style={{ background: '#09e9e9' }}
                                    className="rounded-full ml-2 w-[6px] h-[6px]"
                                  />
                                )}
                                <p
                                  onClick={() => handleCategoryClick(item.id, item.name)}
                                  className={`cursor-pointer ${
                                    showDot ? 'ml-2' : ''
                                  } line-clamp-1 rounded text-xs md:text-base`}
                                >
                                  {item.name}
                                </p>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                      <div className="w-full xl:w-[65%]  2xl:w-[940px] xl:max-h-[240px] hidden-scrollbar-class pr-3">
                        <p
                          style={{
                            color: getStyleValue('content_description', 'color', '#bbbbbb'),
                            fontFamily: getStyleValue('content_description', 'font', ''),
                          }}
                          className={`w-full mt-4 md:mt-5 xl:mt-0 md:text-sm text-xs ${getStyleValue(
                            'content_description',
                            'font_format',
                            '',
                          )}`}
                        >
                          {detailObj?.description}
                        </p>

                        <div
                          style={{
                            color: getStyleValue('metadata_titles', 'color', '#bbbbbb'),
                            fontFamily: getStyleValue('metadata_titles', 'font', ''),
                          }}
                          className={`${getStyleValue(
                            'metadata_titles',
                            'font_format',
                            '',
                          )}  mt-3 xl:grid grid-cols-2 gap-x-2`}
                        >
                          {Object.keys(detailObj.artists).map((artist, index) => (
                            <div className={'flex justify-between mt-2'} key={index}>
                              <p className={'md:text-sm text-xs lg:w-[29%]'}>{artist}</p>
                              <div
                                style={{
                                  color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                                  fontFamily: getStyleValue('metadata_values', 'font', ''),
                                }}
                                className={`${getStyleValue(
                                  'metadata_values',
                                  'font_format',
                                  'font-semibold',
                                )}   lg:w-[70%] flex flex-col  xl:flex-row`}
                              >
                                <p className="md:text-sm text-xs font-semibold text-right lg:text-left">
                                  {detailObj.artists[artist].map((item, index) => (
                                    <span
                                      key={index}
                                      onClick={() => navigate(`/artist/detail/${item.id}`)}
                                    >
                                      {index !== 0 && <span className={''}>{' , '}</span>}
                                      <span className={'cursor-pointer hover:underline'}>
                                        {item.name}
                                      </span>
                                    </span>
                                  ))}
                                </p>
                              </div>
                            </div>
                          ))}
                          {!isEmpty(detailObj.sub_category) && (
                            <div className={'flex justify-between mt-2'}>
                              <p className={' md:text-sm text-xs lg:w-[29%]'}>{t('genre')}</p>
                              <div
                                style={{
                                  color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                                  fontFamily: getStyleValue('metadata_values', 'font', ''),
                                }}
                                className={`${getStyleValue(
                                  'metadata_values',
                                  'font_format',
                                  'font-semibold',
                                )}   lg:w-[70%] flex flex-col  xl:flex-row`}
                              >
                                <p className="md:text-sm text-xs font-semibold text-right lg:text-left">
                                  {detailObj.sub_category.map((item, index) => (
                                    <span
                                      key={index}
                                      onClick={() => handleSubCategory(item.id, item.name)}
                                    >
                                      {index !== 0 && <span className={''}>{' , '}</span>}
                                      <span className={'cursor-pointer hover:underline'}>
                                        {item.name}
                                      </span>
                                    </span>
                                  ))}
                                </p>
                              </div>
                            </div>
                          )}
                          {!isEmpty(detailObj.venues) && (
                            <div className={'flex justify-between mt-2'}>
                              <p className={' md:text-sm text-xs  lg:w-[29%]'}>{t('venue')}</p>
                              <div
                                style={{
                                  color: getStyleValue('metadata_values', 'color', '#bbfa33'),
                                  fontFamily: getStyleValue('metadata_values', 'font', ''),
                                }}
                                className={`${getStyleValue(
                                  'metadata_values',
                                  'font_format',
                                  'font-semibold',
                                )}   lg:w-[70%] flex flex-col  xl:flex-row`}
                              >
                                <p className="md:text-sm text-xs font-semibold text-right lg:text-left">
                                  {detailObj.venues.map((item, index) => (
                                    <span
                                      key={index}
                                      onClick={() => navigate(`/venue/detail/${item.id}`)}
                                    >
                                      {index !== 0 && <span className={''}>{' , '}</span>}
                                      <span className={'cursor-pointer hover:underline'}>
                                        {item.name}
                                      </span>
                                    </span>
                                  ))}
                                </p>
                              </div>
                            </div>
                          )}

                          {detailObj.custom_metadata_new ? (
                            <CustomMetadata
                              customMetadata={detailObj.custom_metadata_new}
                              valueColor={getStyleValue('metadata_values', 'color', '#bbfa33')}
                              valueFontFamily={getStyleValue('metadata_values', 'font', '')}
                              valueFontFormat={getStyleValue(
                                'metadata_values',
                                'font_format',
                                'font-semibold',
                              )}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ContentDetailBottom
                detailObj={detailObj}
                theme={theme}
                removeMargin={true}
                data={data}
                side={'2xl:px-24 xl:px-[4.375vw] md:px-10 px-4'}
              />
            </>
          )}

          {shareModal && (
            <ShareModal
              onClose={() => setShareModal(false)}
              link={create_share_url()}
              detailObj={detailObj}
            />
          )}
        </>
      )}
    </>
  )
}

export default withTheme(ContentDetailPageB)
